// client/src/utils/sanitize.js

/**
 * Sanitizes a string input to prevent XSS attacks
 * @param {*} input - The input to sanitize
 * @returns {*} - The sanitized input, or the original input if not a string
 */
export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
};

/**
 * Sanitizes all string values in an object
 * @param {Object} formData - Object containing form data
 * @returns {Object} - Object with sanitized string values
 */
export const sanitizeFormData = (formData) => {
  const sanitized = {};
  
  // These fields should not be sanitized (e.g., passwords)
  const excludeFields = ['password', 'confirmPassword'];
  
  for (const [key, value] of Object.entries(formData)) {
    if (typeof value === 'string' && !excludeFields.includes(key)) {
      sanitized[key] = sanitizeInput(value);
    } else {
      sanitized[key] = value;
    }
  }
  
  return sanitized;
};